import DOMPurify from 'dompurify'

export default function sanitizeInputToDisplayName(input) {
  // Sanitize HTML using DOMPurify
  let sanitizedInput = DOMPurify.sanitize(input)

  // Prevent directory traversal attacks by replacing any combination of '.' and '/' with ''
  sanitizedInput = sanitizedInput.replace(/(\.*\/)|\/|(\.\.+)/g, '')

  // Prevent string injection by replacing 'eval(' with ''
  sanitizedInput = sanitizedInput.replace(/eval\(/g, '')

  // Prevent browser URL policy bypass by replacing 'javascript:' with ''
  sanitizedInput = sanitizedInput.replace(/javascript:/g, '')

  // Prevent authentication across tabs by replacing 'localStorage' with ''
  sanitizedInput = sanitizedInput.replace(/localStorage/g, '')

  // Sanitize out characters that would not appear in a valid name
  sanitizedInput = sanitizedInput.replace(/[^a-zA-Z0-9. '-]/g, '')

  return sanitizedInput
}
